import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function ParticipacaoEmpresa({
  participacoes,
  showRestricao,
  isConsultaNova,
}: {
  participacoes: any;
  showRestricao: boolean;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();

  if (isConsultaNova) {
    const cols = [
      { field: 'documentoParticipante', label: t('documentoParticipante') },
      { field: 'participante', label: t('participante') },
      { field: 'documentoEmpresa', label: t('documentoEmpresa') },
      { field: 'empresa', label: t('empresa') },
      { field: 'tipo', label: t('tipo') },
      { field: 'percentual', label: t('percentual') },
      { field: 'dataInicio', label: t('dataInicio') },
      { field: 'dataAtualizacao', label: t('dataAtualizacao') },
      ...(showRestricao ? [{ field: 'statusRestricao', label: t('restricao') }] : []),
    ];

    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: '#EFF6FF',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i className="pi pi-sitemap" style={{ color: '#2563EB', fontSize: '18px' }} />
          </div>
          <div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
              {t('participacaoEmpresa')}
            </h3>
            {participacoes?.length > 0 && (
              <span style={{ fontSize: 'small', color: '#6B7280' }}>
                {participacoes.length} participação{participacoes.length !== 1 ? 'ões' : ''}
              </span>
            )}
          </div>
        </div>

        <div style={{ overflowX: 'auto', borderRadius: '10px', border: '1px solid #F3F4F6' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: 'small' }}>
            <thead>
              <tr style={{ backgroundColor: '#F9FAFB', borderBottom: '2px solid #E5E7EB' }}>
                {cols.map(c => (
                  <th
                    key={c.field}
                    style={{
                      padding: '10px 14px',
                      fontWeight: 700,
                      color: '#6B7280',
                      fontSize: '0.7rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.04em',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {participacoes && participacoes.map((p: any, idx: number) => (
                <tr
                  key={idx}
                  style={{ borderBottom: idx < participacoes.length - 1 ? '1px solid #F3F4F6' : 'none' }}
                  onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#EFF6FF')}
                  onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  {cols.map(c => (
                    <td key={c.field} style={{ padding: '10px 14px', color: '#374151' }}>
                      {p[c.field] ?? '—'}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <Panel header={t('participacaoEmpresa')}>
      <DataTable size="small" value={participacoes} tableStyle={{ minWidth: '50rem' }}>
        <Column field="documentoParticipante" header={t('documentoParticipante')}></Column>
        <Column field="participante" header={t('participante')}></Column>
        <Column field="documentoEmpresa" header={t('documentoEmpresa')}></Column>
        <Column field="empresa" header={t('empresa')}></Column>
        <Column field="tipo" header={t('tipo')}></Column>
        <Column field="percentual" header={t('percentual')}></Column>
        <Column field="dataInicio" header={t('dataInicio')}></Column>
        <Column field="dataAtualizacao" header={t('dataAtualizacao')}></Column>
        {showRestricao && (<Column field="statusRestricao" header={t('restricao')}></Column>)}
      </DataTable>
    </Panel>
  );
}
